module.exports = __webpack_public_path__ + "static/media/core.3847a4a1.png";